import { LeftOutlined, RightCircleOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { Badge, Button, Checkbox, Divider, Typography } from "antd";
import { useState } from "react";
import { useHistory } from "react-router";
import OrderButton from "../../../components/OrderButton";

const { Title, Text } = Typography;

const NewAndPreparedCart=({cartItems,addCount,menudata,handleCheckboxChange,type,setType})=>{

    const history = useHistory();
    

    return(
        <div>
            <div style={{display:"flex",justifyContent:"center"}}>
            <div className="cart-tab">
              <Button
                onClick={() => setType("new")}
                className={
                  type == "new" ? "active-cart-btn" : "default-cart-btn"
                }
              >
                New Orders
              </Button>
              <Button
                onClick={() => setType("prepare")}
                className={
                  type == "prepare" ? "active-cart-btn" : "default-cart-btn"
                }
              >
                Preparing
              </Button>
            </div>
            </div>
            <div className="cart-item-button">
              {type === "new" ? (
                <div>
                  {cartItems
                    ?.filter((item) => item.cart_item_status == "NEW")
                    ?.map((itemcarts) => (
                      <div className="cart-sections" key={itemcarts.id}>
                        <div style={{ textAlign: "left" }}>
                          <Title level={5}>{itemcarts.name}</Title>
                          <Text type="secondary">{itemcarts.description}</Text>
                          <div className="price-count">
                            <div className="theme-red cart-price">
                              $ {itemcarts.price}
                            </div>
                            <div>
                              <OrderButton
                                count={itemcarts.count ? itemcarts.count : 1}
                                increment={() => addCount(itemcarts, true)}
                                decrement={() => addCount(itemcarts, false)}
                              />
                            </div>
                          </div>
                        </div>

                        <Divider style={{ margin: 0 }} />
                      </div>
                    ))}
                </div>
              ) : (
                <div>
                  {menudata?.map((value) => (
                    <div className="cart-sections">
                      <div
                        style={{
                          textAlign: "left",
                          background:
                            value.cart_item_status == "SERVED"
                              ? "#D2FFD1"
                              : "#FFF8D1",
                        }}
                      >
                        <div style={{ margin: "0 10px" ,padding:"12px 0px"}}>
                          <Title level={5}>{value.name}</Title>
                          <Text type="secondary">{value.description}</Text>
                          <div className="price-count">
                            <div className="theme-red">${value.price}</div>
                            <div>
                             {value.cart_item_status == "SERVED" ? "Served" : "Mark as Served"}{" "}
                              <Checkbox
                                className="served served-checkbox"
                                checked={value.cart_item_status == "SERVED"}
                                onChange={(e) =>
                                  value.cart_item_status !== "SERVED" &&
                                  handleCheckboxChange(e.target.checked, value)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <Divider style={{ margin: 0 }} />
                    </div>
                  ))}
                </div>
              )}
              <div>
            
              </div>
            </div>
        </div>
    )
}
export default NewAndPreparedCart;